"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _GatsbyImage = _interopRequireDefault(require("../GatsbyImage"));

var _theme = require("../../theme");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var FilePicker = function FilePicker(props) {
  var _props$buttonText = props.buttonText,
      buttonText = _props$buttonText === void 0 ? 'Edit' : _props$buttonText,
      onClick = props.onClick,
      onRemove = props.onRemove,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value;
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(ImageContainer, {
    type: value === null || value === void 0 ? void 0 : value.icon
  }, (value === null || value === void 0 ? void 0 : value.type) === 'image' && /*#__PURE__*/_react.default.createElement(_GatsbyImage.default, {
    image: value,
    objectFit: "cover",
    objectPosition: "50% 50%",
    alt: value.alt,
    style: {
      width: '100%',
      height: '100%'
    }
  }), (value === null || value === void 0 ? void 0 : value.type) === 'application' && /*#__PURE__*/_react.default.createElement(File, null, /*#__PURE__*/_react.default.createElement("img", {
    src: value === null || value === void 0 ? void 0 : value.icon
  }))), /*#__PURE__*/_react.default.createElement(Buttons, null, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, (value === null || value === void 0 ? void 0 : value.filename) && /*#__PURE__*/_react.default.createElement(FileName, null, value.filename), /*#__PURE__*/_react.default.createElement(_antd.Space, null, value && /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Remove",
    onClick: onRemove,
    danger: true,
    size: "small"
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: buttonText,
    onClick: onClick,
    size: "small"
  })))));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n"])));

var ImageContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  height: 80px;\n  width: 80px;\n  margin-right: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n"])), _theme.colors.tertiary);

var File = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  img {\n    height: 30px;\n  }\n"])));

var FileName = _styledComponents.default.article(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 12px;\n  line-height: 16px;\n  word-break: break-word;\n"])));

var Buttons = _styledComponents.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  flex: 1;\n"])));

var _default = FilePicker;
exports.default = _default;